angular.module('webremote.directive.navigation', [])

require('./navigationBar/controller')
